// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__31wAZ","form":"styles_form__2HNuT"};